module.exports = __webpack_public_path__ + "static/img/khk007.690c3b6c.jpg";